export default "__VITE_ASSET__DzIZGKQ___"